import { AvatarImageToolsDTO, ThemeImageToolsDTO } from "@ep-om/jira-control/avatar/upload-avatar/upload-avatar.component";

export function compressImage(obj: AvatarImageToolsDTO): Promise<string> {
  const { src, outWidth, outHeight } = obj;
  let quality = obj.quality;
  if (!quality) {
    quality = 0.5;
  }
  return new Promise<string>((res, rej) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const [inputWidth, inputHeight] = [img.naturalWidth, img.naturalHeight];

      const elem = document.createElement('canvas');
      elem.width = outWidth;
      elem.height = outHeight;

      let [sourceX, sourceY] = [0, 0];

      if (inputWidth > inputHeight) {
        sourceX = (inputWidth - inputHeight) * 0.5
      } else if (inputHeight > inputWidth) {
        sourceY = (inputHeight - inputWidth) * 0.5
      }
      // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/drawImage
      const ctx = elem.getContext('2d');
      const sourceSize = Math.min(inputWidth - sourceX, inputHeight - sourceY)
      ctx.drawImage(img, sourceX, sourceY, sourceSize, sourceSize, 0, 0, outWidth, outHeight);
      const data = ctx.canvas.toDataURL('image/png', quality);
      res(data);
    }
    img.onerror = error => rej(error);
  })
}

export function compressImageForTheme(obj: ThemeImageToolsDTO): Promise<string> {
  const src = obj.src;
  let quality = obj.quality;
  if (!quality) {
    quality = 0.5;
  }
  return new Promise<string>((res, rej) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const [inputWidth, inputHeight] = [img.naturalWidth, img.naturalHeight];

      const elem = document.createElement('canvas');
      const finalOutHeight = (inputHeight / inputWidth) * inputWidth;
      elem.width = inputWidth;
      elem.height = finalOutHeight;

      // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/drawImage
      const ctx = elem.getContext('2d');
      ctx.drawImage(img, 0, 0, inputWidth, inputHeight, 0, 0, inputWidth, finalOutHeight);
      const data = ctx.canvas.toDataURL('image/png', quality);
      res(data);
    }
    img.onerror = error => rej(error);
  })
}
